import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';

const CookieConsent = () => {
  const { language } = useLanguage();
  const [show, setShow] = useState(false);
  const it = language === 'it';

  useEffect(() => {
    const accepted = localStorage.getItem('mf_cookies');
    if (!accepted) {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('mf_cookies', 'accepted');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 animate-fade-in" data-testid="cookie-consent">
      <div className="bg-white dark:bg-stone-800 rounded-2xl shadow-2xl border border-stone-200 dark:border-stone-600 p-5">
        <div className="flex gap-3">
          <Cookie className="h-6 w-6 text-amber-500 shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-stone-700 dark:text-stone-200 mb-3">
              {it
                ? 'Questo sito utilizza cookie tecnici per il funzionamento. Proseguendo accetti la nostra '
                : 'This site uses technical cookies. By continuing you accept our '}
              <Link to="/privacy" className="text-emerald-700 dark:text-emerald-400 hover:underline font-medium">
                {it ? 'Privacy Policy' : 'Privacy Policy'}
              </Link>.
            </p>
            <div className="flex gap-2">
              <Button size="sm" onClick={accept} className="bg-emerald-700 hover:bg-emerald-800 text-white rounded-full px-5 text-xs" data-testid="accept-cookies-btn">
                {it ? 'Accetto' : 'Accept'}
              </Button>
              <Button size="sm" variant="ghost" onClick={accept} className="text-stone-500 rounded-full text-xs">
                {it ? 'Chiudi' : 'Close'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
